import Swiper from "swiper/bundle";

const Hero = {
  init: () => {
    const heroSlider = new Swiper(".swiper", {
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      speed: 1000,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
    });
  },
};

export default Hero;
